import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./lib/i18n";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Rooms from "./pages/Rooms";
import Gallery from "./pages/Gallery";
import Location from "./pages/Location";
import Activities from "./pages/Activities";
import Booking from "./pages/Booking";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";

const TOAST_OPTIONS = {
  style: {
    background: "#2C241B",
    color: "#F9F6F0",
    border: "1px solid rgba(249,246,240,0.1)",
    borderRadius: 0,
    fontFamily: "Outfit, sans-serif",
    fontSize: "13px",
    letterSpacing: "0.02em",
  },
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/chambres" element={<Rooms />} />
              <Route path="/rooms" element={<Rooms />} />
              <Route path="/galerie" element={<Gallery />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/grand-popo" element={<Location />} />
              <Route path="/location" element={<Location />} />
              <Route path="/activites" element={<Activities />} />
              <Route path="/activities" element={<Activities />} />
              <Route path="/reserver" element={<Booking />} />
              <Route path="/book" element={<Booking />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<Home />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-center" toastOptions={TOAST_OPTIONS} />
      </LanguageProvider>
    </div>
  );
}

export default App;
